class FormSelect {
    constructor(el) {
        if (!this.set(el)) return;
        this.init();
    }

    set(el) {
        if (!el) return false;

        this.root = el;
        this.toggleEl = this.root.querySelector('[form-select-toggle]');
        this.dropdownEl = this.root.querySelector('[form-select-dropdown]');
        this.itemEl = this.root.querySelectorAll('[form-select-item]');
        this.selectTextEl = this.root.querySelector('[form-select-text]');
        this.selectEl = this.root.querySelector('[form-select-select]');

        return true;
    }

    init() {
        this.setToggle();
        this.setOptions();
    }

    setToggle() {
        if (!this.toggleEl || !this.dropdownEl) return;
        this.toggleEl.addEventListener('click', event => {
            this.dropdownEl.classList.toggle('max-h-0');
            this.dropdownEl.classList.toggle('max-h-[220px]');
            this.dropdownEl.classList.toggle('pointer-events-none');

            this.toggleEl.classList.toggle('rounded-bl-none');
            this.toggleEl.classList.toggle('rounded-br-none');
        });
    }

    setOptions() {
        if (!this.itemEl) return;

        this.itemEl.forEach(item => {
            item.addEventListener('click', event => {
                const { currentTarget } = event;
                const value = currentTarget.getAttribute('form-select-item');

                if (value && this.selectEl) {
                    this.selectEl.value = value;
                    this.selectTextEl.innerHTML = value;
                    this.selectEl.dispatchEvent(
                        new Event('change', { bubbles: true })
                    );
                }

                this.dropdownEl.classList.add('max-h-0');
                this.dropdownEl.classList.remove('max-h-[220px]');
                this.dropdownEl.classList.toggle('pointer-events-none');

                this.toggleEl.classList.remove('rounded-bl-none');
                this.toggleEl.classList.remove('rounded-br-none');
            });
        });
    }
}

export const initSelects = () => {
    const sections = document.querySelectorAll('[form-select]');
    if (!sections) return;

    sections.forEach(el => {
        new FormSelect(el);
    });
};
